import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import { InputBase, InputContainer, InputHint, IInputBaseProperties, InputSideButton, InputMask, InputSize } from "../input";
import { PopupProvider, PopupTrigger, Popup, PopupAlign } from "../popup";
import { Datepicker } from "../datepicker";
import { CalendarViewMode } from "../../enumerations";
import { UUID } from "../../utils/utils";
import { EventManager } from "../popup/globals";


interface IProperties extends IInputBaseProperties
{
    /**
     * Enthält alle Child-Elemente.
     */
    children?: JSX.Element | JSX.Element[],

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Anzeigetext der Checkbox.
     */
    label?: string,


    date?: moment.Moment,

    /**
     * Setzt einen Hilfetext.
     */
    hint?: string | JSX.Element,

    alignPopup?: PopupAlign,

    onDateChange?: (date: moment.Moment) => void
}

interface IState
{
    value?: string
}

export class DateTextBox extends React.Component<IProperties, IState>
{
    private popupId: string = "";

    public static defaultProps: Partial<IProperties> = {
        alignPopup: PopupAlign.targetNodeBottomLeft
    };

    constructor(props: IProperties)
    {
        super(props);
        this.state = {};

        if (props.date && props.date.isValid())
        {
            this.state = {
                value: props.date.format("L")
            };
        }

        this.popupId = UUID();
    }

    private convertStringToDate(str: string): moment.Moment
    {
        var date: moment.Moment = moment(str, "DD.MM.YYYY", true);
        if (date.isValid())
            return date;
        else
            return null;
    }

    private setValue(value: string)
    {
        this.setState({ value });
    }

    private callDateChange(date: moment.Moment)
    {
        this.props.onDateChange && this.props.onDateChange(date);
    }

    private onTextChange = (value: any[], originalValue: string[]) =>
    {
        this.setValue(value[0]);

        var date: moment.Moment = this.convertStringToDate(value[0]);
        if (date)
            this.callDateChange(date);
    }

    private onDatepickerDateChanged = (date: moment.Moment, type: string): void =>
    {
        if (type === "day")
        {
            EventManager.has("hide") && EventManager.emit("hide");
            this.setValue(date.format("L"));
            this.callDateChange(date);
        }
    }

    /**
     * Gibt eine <label /> Element zurück. Falls nötig.
     */
    private renderLabel()
    {
        const { id, label } = this.props;

        if (label != null)
        {
            return <label htmlFor={id}>{label}</label>
        }
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        const { style, children, hint, alignPopup } = this.props;
        const { value } = this.state;
        const date: moment.Moment = this.convertStringToDate(value);

        return (
            <InputContainer style={style}>
                {this.renderLabel()}
                <div className="textbox">
                    <InputBase
                        mask={InputMask.date}
                        size={InputSize.small}
                        value={value}
                        onTextChange={this.onTextChange}
                        {...this.props} />
                    <PopupProvider
                        id={this.popupId}
                        trigger={PopupTrigger.Click}
                        refPropName="elementRef">
                        <InputSideButton icon="calendar" />
                    </PopupProvider>
                    {children}
                </div>
                {
                    hint &&
                    <InputHint style={{
                        marginTop: 5,
                    }}>
                        {hint}
                    </InputHint>
                }
                <Popup
                    id={this.popupId}
                    align={alignPopup}>
                    <Datepicker
                        selectedDate={date}
                        isSelectedRangeVisible={true}
                        selectedViewMode={CalendarViewMode.day}
                        onDateChanged={this.onDatepickerDateChanged} />
                </Popup>
            </InputContainer>
        );
    }
}